<!--
 * @Author: XiaoHuwei
 * @Date: 2020-07-17 17:57:09
 * @LastEditors: XiaoHuwei
 * @LastEditTime: 2021-08-06 17:30:55
 * @FilePath: /span/src/App.vue
-->
<template>
  <div style="padding:0 15px;" v-html="html">
  
     
   
  
  </div>
</template>

<script>

export default {

  created() {

  },
  mounted() {
    if(!this.getQueryString('type')){
       // return alert('参数不合法')
       return document.write('参数不合法')
    }
    this.$axios(`https://api.txcb.com/qaHelp/helpDocument?type=${this.getQueryString('type')}`)
    .then(res=>{
      this.html = res.data.data.data[0].content
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'setTitle', payload: res.data.data.data[0].title }))
    })

  },
  methods: {
    getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
    }

  },
  data() {
    return {
          html:''
    };
  },
};
</script>

<style scoped>
.ku-img {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}
.ku-img img {
  width: 100%;
  height: auto;
}
.time {
  background: #fef3e2;
  margin: 0 auto;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e82038;
}
.desc {
  position: absolute;
  background: url(./assets/background.png);
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.desc .right {
  border: 0px solid red;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.gankuai {
  color: #e82038;
}
.btn {
  background: #e82038;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.line {
  position: absolute;
  background: #ffc9aa;
}
.shops {
  border: 0px solid #ffffff;
  position: absolute;
  z-index: 9999;
}
.shoBox {
  position: absolute;
  border: 0px solid #ffffff;
  width: 100%;
  border: 0px solid #ffffff;
  background: url(./assets/di.png);
  background-size: 100%;
}
.shoBox::after {
  content: "";
  width: 42%;
}
.shoBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  position: relative;
}
.tips {
  position: absolute;
  border: 0px solid #ffffff;
  z-index: 999999999999;
  background: linear-gradient(90deg, #f6e7e7, #faf1ed);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;
  color: #851a21;
}
.tips span {
  height: 25%;
}
.van-dialog {
  z-index: 999999999999999999999999999999999 !important;
}
.share {
  position: absolute;
  width: 100%;
  z-index: 999999999;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>